/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["Pazartesi", "Sal\u0131", "\xC7ar\u015Famba", "Per\u015Fembe", "Cuma", "Cumartesi", "Pazar"], e = ["Ocak", "\u015Eubat", "Mart", "Nisan", "May\u0131s", "Haziran", "Temmuz", "A\u011Fustos", "Eyl\xFCl", "Ekim", "Kas\u0131m", "Aral\u0131k"], t = "Y\u0131llar", s = "Y\u0131l", l = "Ay", n = "Hafta", k = "G\xFCn", r = "Bug\xFCn", d = "Etkinlik Yok", m = "T\xFCm g\xFCn", y = "Sil", i = "Etkinlik ekle", o = "dddd D MMMM YYYY", Y = { weekDays: a, months: e, years: "Y\u0131llar", year: "Y\u0131l", month: "Ay", week: "Hafta", day: "G\xFCn", today: "Bug\xFCn", noEvent: "Etkinlik Yok", allDay: "T\xFCm g\xFCn", deleteEvent: "Sil", createEvent: "Etkinlik ekle", dateFormat: "dddd D MMMM YYYY" };
export {
  m as allDay,
  i as createEvent,
  o as dateFormat,
  k as day,
  Y as default,
  y as deleteEvent,
  l as month,
  e as months,
  d as noEvent,
  r as today,
  n as week,
  a as weekDays,
  s as year,
  t as years
};
